import dayjs from 'dayjs';

export const safeParse = (jsonstring): any => {
  let json;

  if (jsonstring) {
    try {
      json = JSON.parse(jsonstring);
    } catch (e) {
      console.warn(e);
    }
  }

  return json;
};

export const isBetween = (start, end) => {
  return (start ? dayjs().isAfter(start) : true) && (end ? dayjs().isBefore(end) : true);
};

export const headFactor = ({ productName }) => {
  return {
    title: `Under Armour安德玛中国官网|${productName || '商品不存在'}`,
    meta: [
      {
        hid: 'viewport',
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `安德玛${productName || ''}`
      },
      {
        hid: 'description',
        name: 'description',
        content: `欢迎登录Under Armour安德玛中国官网，在线选购安德玛${
          productName || ''
        }。更多跑步、训练、运动休闲、篮球、瑜伽、高尔夫、户外垂钓等专业运动装备尽在www.underarmour.cn`
      }
    ]
  };
};

export const getUserInfo = () => {
  let userInfo = {};

  try {
    userInfo = JSON.parse(localStorage.getItem('userInfo'));
  } catch (e) {
    console.log('JSON parse error');
  }

  return userInfo;
};

export const getViewportTop = seletor => {
  if (!seletor) return 0;

  const ref = document.querySelector(seletor);

  if (!seletor) return 0;

  return ref.getBoundingClientRect().top;
};

export const getOffsetHeight = seletor => {
  if (!seletor) return 0;

  const ref = document.querySelector(seletor);

  if (!seletor) return 0;

  return ref.offsetHeight || 0;
};

export const clickOutside = (seletor, callback) => {
  const handler = e => {
    const el = document.querySelector(seletor);

    if (el && !el.contains(e.target)) callback();
  };

  document.addEventListener('click', handler);

  return () => document.removeEventListener('click', handler);
};
